import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faSignOutAlt,
  faTshirt,
  faInfo,
  faCalendarAlt,
  faBookmark,
  faExclamation,
  faCog,
  faBullhorn,
  faUser
} from '@fortawesome/free-solid-svg-icons'

import * as Constants from '../../../helpers/Constants'
import * as Strings from './strings'
import * as Styles from './styles'

export const BookingListItems = props => {
  if (!props.show) {
    return null
  }

  return (
    <div>
      <List>
        <ListItem
          selected={props.selected === Constants.BOOK_LAUNDRY_FOCUSED}
          button
          onClick={() => props.navigateTo('/laundrybookings')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faTshirt} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.BOOK_LAUNDRY[props.language]}</p>
          </ListItemText>
        </ListItem>
        <ListItem
          selected={props.selected === Constants.MY_BOOKINGS_FOCUSED}
          button
          onClick={() => props.navigateTo('/mylaundrybookings')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faBookmark} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.MY_LAUNDRY_BOOKINGS[props.language]}</p>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  )
}

export const BookingSystemListItems = props => {
  if (!props.show) {
    return null
  }

  return (
    <div>
      <List>
        <ListItem
          selected={props.selected === Constants.BOOKING_SYSTEM_FOCUSED}
          button
          onClick={() => props.navigateTo('/bookingsystems')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faCalendarAlt} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.BOOKING_SYSTEMS[props.language]}</p>
          </ListItemText>
        </ListItem>
        <ListItem
          selected={
            props.selected === Constants.MY_BOOKING_SYSTEM_BOOKINGS_FOCUSED
          }
          button
          onClick={() => props.navigateTo('/mybookings')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faBookmark} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.MY_BOOKINGS[props.language]}</p>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  )
}

export const ErrorReportListItems = props => {
  if (!props.show) {
    return null
  }

  return (
    <div>
      <List>
        <ListItem
          selected={props.selected === Constants.REPORT_AN_ERROR_FOCUSED}
          button
          onClick={() => props.navigateTo('/newerrorreport')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faExclamation} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.REPORT_AN_ERROR[props.language]}</p>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  )
}

export const NewsListItems = props => {
  if (!props.show) {
    return null
  }

  return (
    <div>
      <List>
        <ListItem
          selected={props.selected === Constants.NEWS_FOCUSED}
          button
          onClick={() => props.navigateTo('/news')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faBullhorn} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.NEWS[props.language]}</p>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  )
}

export const InfoListItems = props => {
  if (!props.show) {
    return null
  }

  return (
    <div>
      <List>
        <ListItem
          selected={props.selected === Constants.INFO_BOARD_FOCUSED}
          button
          onClick={() => props.navigateTo('/communityinformation')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faInfo} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p>{Strings.default.INFORMATION_SETTINGS[props.language]}</p>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  )
}

export const SecondaryListItems = props => (
  <div>
    <List>
      <ListItem
        button
        onClick={() => props.navigateTo('/mypage')}
        selected={props.selected === Constants.MY_PAGE_FOCUSED}
      >
        <div style={Styles.default.iconContainer}>
          <FontAwesomeIcon icon={faUser} color={'#3B424D'} />
        </div>
        <ListItemText style={{ position: 'absolute', left: 55 }}>
          <p style={{ color: '#3B424D' }}>
            {Strings.default.MY_PAGE[props.language]}
          </p>
        </ListItemText>
      </ListItem>
      {!props.showToAssoicationSettings ? null : (
        <ListItem
          button
          onClick={() => window.open('https://admin.homepal.se', '_blank')}
        >
          <div style={Styles.default.iconContainer}>
            <FontAwesomeIcon icon={faCog} color={'#3B424D'} />
          </div>
          <ListItemText style={{ position: 'absolute', left: 55 }}>
            <p style={{ color: '#3B424D' }}>
              {Strings.default.TO_ASSOCIATION_SETTINGS[props.language]}
            </p>
          </ListItemText>
        </ListItem>
      )}
      <ListItem button onClick={() => props.signOut()}>
        <div style={Styles.default.iconContainer}>
          <FontAwesomeIcon icon={faSignOutAlt} color={'#e57373'} />
        </div>
        <ListItemText style={{ position: 'absolute', left: 55 }}>
          <p style={{ color: '#e57373' }}>
            {Strings.default.SIGN_OUT[props.language]}
          </p>
        </ListItemText>
      </ListItem>
    </List>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/listItems/index.js